/* eslint-disable */

export interface IUndergroundInfoSchema {
  /** ID метро **/
  id?: number;
  /** Цвет линии метро, hex **/
  lineColor?: string;
  /** Тип линии метро МЦД/МЦК **/
  lineType?: ELineType;
  /** Название **/
  name?: string;
  /** Год сдачи для строящейся станции **/
  releaseYear?: number;
  /** Время в пути в минутах до метро, мин **/
  travelTime?: number;
  /** Способ передвижения до метро **/
  travelType?: ETravelType;
  /** Является ли станция строящейся **/
  underConstruction?: boolean;
  /** Ссылка (ЧПУ) **/
  url?: string;
}
export enum ELineType {
  /** МЦД-1 **/
  'Mcd1' = 'mcd1',
  /** МЦД-2 **/
  'Mcd2' = 'mcd2',
  /** МЦД-3 **/
  'Mcd3' = 'mcd3',
  /** МЦД-4 **/
  'Mcd4' = 'mcd4',
  /** МЦК **/
  'Mck' = 'mck',
}
export enum ETravelType {
  /** На транспорте **/
  'Transport' = 'transport',
  /** Пешком **/
  'Walk' = 'walk',
}
